export default __webpack_public_path__ + "static/new7-0dde7c63727a982860ccf47e26688a92.jpg";